import { createSlice } from "@reduxjs/toolkit";


const salesOrderSlice = createSlice({
    name: "salesOrder",
    initialState: {
        salesOrderData: [],
        totalItems: [],
        itemsPerPage: 10
    },
    reducers: {
        setSalesOrderData: (state, action) => {
            state.salesOrderData = action.payload;
        },

        setTotalItems: (state, action) => {
            state.totalItems = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;
        }


    }
});

export const {
    setSalesOrderData,
    setTotalItems,
    setItemsPerPage
} = salesOrderSlice.actions;

export default salesOrderSlice.reducer;